import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { storefrontShortcutsBarAccessControl } from '../access-control/storefrontShortcutsBarAccess.configuration'

const StorefrontShortcutsBarRetailerListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontShortcutsBarRetailerListPage" */
      '../pages/StorefrontShortcutsBarRetailerListPage'
    )
)

const StorefrontShortcutsBarRetailerCategoryEditPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontShortcutsBarRetailerCategoryEditPage" */
      '../pages/StorefrontShortcutsBarRetailerCategoryEditPage'
    )
)

const StorefrontShortcutsBarRetailerEditPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontShortcutsBarRetailerEditPage" */
      '../pages/StorefrontShortcutsBarRetailerEditPage'
    )
)

// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const storefrontShortcutsBarAdminRouter = (
  <DomainRoute
    route="app-admin-storefront-shortcuts-bar"
    accessControl={storefrontShortcutsBarAccessControl}
  >
    <DashSwitch>
      <DomainRoute
        exact
        route="app-admin-storefront-shortcuts-bar-retailer-category-edit"
        component={StorefrontShortcutsBarRetailerCategoryEditPage}
      />
      <DomainRoute
        exact
        route="app-admin-storefront-shortcuts-bar-retailer-edit"
        component={StorefrontShortcutsBarRetailerEditPage}
      />
      <DomainRoute
        exact
        route="app-admin-storefront-shortcuts-bar"
        component={StorefrontShortcutsBarRetailerListPage}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
